._preview_1t6ts_1 {
  position: relative; }
  ._preview_1t6ts_1 ._previewItemWrapper_1t6ts_3 {
    position: relative; }
  ._preview_1t6ts_1 ._previewPinElement_1t6ts_5 {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1000;
    overflow: hidden; }
  ._preview_1t6ts_1 ._previewFixedHeader_1t6ts_9 {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1001;
    overflow: hidden; }
